import * as React from 'react'
import TimeFields from './TimeFields'
import { PartnerShape } from '../../api/api_data_types'

type PartnerRecordTimesFormProps = {
  partnerFields: {
    times_attributes: {
      [key: string]: {
        id?: number
        time: number
        worktype_id: number
        comment: string
        partner_time: boolean
        _destroy?: boolean
      }
    }
    partner_id?: number
  }
  fieldNameFn: (field: string) => string
  setPartnerFields: (partnerFields: any) => void
  availableWorktypes: [string, number][]
  availablePartners: PartnerShape[]
  allPartners: PartnerShape[]
}

export default function PartnerRecordTimesForm(props: PartnerRecordTimesFormProps) {
  const { partnerFields, setPartnerFields, availableWorktypes, availablePartners, allPartners, fieldNameFn } = props
  const notMarkedForDestruction = time => !time._destroy
  const notRemovedTimes = Object.fromEntries(
    Object.entries(partnerFields.times_attributes).filter(([_, time]) => notMarkedForDestruction(time))
  )
  const canRemove = Object.keys(notRemovedTimes).length > 1

  return (
    <div>
      {Object.entries(partnerFields.times_attributes).map(([key, time], index) => (
        <TimeFields
          key={key}
          className={Object.keys(partnerFields.times_attributes).length === index + 1 ? '' : 'mb-2'}
          idKey={key}
          fieldNameFn={(field: string) => `${fieldNameFn(`times_attributes][${index}][${field}`)}`}
          timeFields={ {...time, partner_time: true, partner_id: partnerFields.partner_id} }
          setTimeFields={data => {
            setPartnerFields({
              ...partnerFields,
              times_attributes: {
                ...partnerFields.times_attributes,
                [key]: data,
              },
            })
          }}
          availableWorktypes={availableWorktypes}
          handleRemove={() => {
            const newTimes = { ...partnerFields.times_attributes }
            delete newTimes[key]
            setPartnerFields({
              ...partnerFields,
              times_attributes: newTimes,
            })
          }}
          showSignControl={false}
          allowRemove={canRemove}
        />
      ))}
    </div>
  )
}
